module.exports = __webpack_public_path__ + "static/media/franchise-with-us.eafa23e8.jpg";